import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/frontend/components/general/wiederruf-client.tsx");
